/* global rp$, $ajax */
const pixastic = require('public/js/lib/insignia/pixastic.custom');
const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const initializeVisualizerConfig = require('public/js/lib/insignia/config');
const localStorage = require('public/js/lib/local-storage.js');
const isEqual = require('lodash/isEqual');

require('public/css/external/insignia/config.scss');
require('public/templates/components/accessorizer_modal/accessorizer_modal.scss');

const VISUALIZER_VIEW_CLASSNAME = 'visualizer-view';
const VISUALIZER_VIEWS = {
	accessorizer: 'accessorizer',
	loading: 'loading',
	error: 'error',
};
const ALT_VEHICLE_MESSAGE_SELECTOR = '#configuratorAlternativeCarMsg';
const ALT_VEHICLE_SELECTOR = '#configuratorAltVehicle';
const LOCAL_STORAGE_KEY = 'accessorizer_modal_data';

let accessorizerLoaded = false;
let accessorizerRendered = false;
let visualizerConfig = {};
let accessorizerResponse = null;

function accessorizerModal() {
	const modal = rp$('#accessorizerModal');
	const visualizerButton = rp$('.accessory-visualizer-button');
	const sku = encodeURIComponent(modal.data('sku')).toUpperCase();
	const brand = encodeURIComponent(modal.data('brand'));

	const cachedData = localStorage.getItem(LOCAL_STORAGE_KEY)

	if (cachedData && isEqual(cachedData.searchCriteria, {brand, sku})) {
		completeAjaxRequest(cachedData)
	}

	if (!accessorizerLoaded) {
		$ajax({
			method: 'GET',
			url: `/ajax/accessory-visualization/${brand}/${sku}`,
			dataType: 'json',
			success: (response) => {
				completeAjaxRequest(response, visualizerButton);
				localStorage.setItem(LOCAL_STORAGE_KEY, {data: response, searchCriteria: {brand, sku}});
			},
		});
	}

	modal.on('shown.bs.modal', function() {
		if (accessorizerLoaded && accessorizerResponse) {
			// We only need to render once, not ever time the modal is opened
			if (!accessorizerRendered) {
				const { configurator, products, carMapping } = accessorizerResponse;

				pixastic();
				activateModalView(VISUALIZER_VIEWS.accessorizer);

				if (carMapping && !carMapping.isExactMatch) {
					const vehicleName = [carMapping.year, carMapping.make, carMapping.model, carMapping.trim]
						.filter(piece => !!piece)
						.join(' ');
					if (vehicleName) {
						rp$(ALT_VEHICLE_SELECTOR).text(vehicleName);
						rp$(ALT_VEHICLE_MESSAGE_SELECTOR).show();
					}
				}

				visualizerConfig = initializeVisualizerConfig();
				visualizerConfig.load(configurator);
				visualizerConfig.add(products);
				accessorizerRendered = true;
			}
		} else {
			activateModalView(VISUALIZER_VIEWS.error);
		}
	});
}

function activateModalView(viewName) {
	const viewToShow = rp$(`.${VISUALIZER_VIEW_CLASSNAME}.${viewName}`);
	viewToShow.show();

	for (const viewKey in VISUALIZER_VIEWS) {
		if (VISUALIZER_VIEWS[viewKey] !== viewName) {
			const view = rp$(`.${VISUALIZER_VIEW_CLASSNAME}.${VISUALIZER_VIEWS[viewKey]}`);
			view.hide();
		}
	}
}

function completeAjaxRequest(response, visualizerButton) {
	activateModalView(VISUALIZER_VIEWS.loading); // This holds the space for the visualizer until it is rendered
	accessorizerResponse = response;
	accessorizerLoaded = true;
	visualizerButton.show();
}

runScriptOnReady(
	'accessorizer_modal',
	accessorizerModal,
);
